import axios from "axios";
import { getApiURL, axiosTimeout } from "@/config";

// 'Access-Control-Allow-Origin': '*',
// 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',

// let token = "";
let api = null;
let wfApi = null;
let forLogin = null;
function buildApi() {
  // token = getLocalStorageItem("city-center-bearer-token");
  const cityCenterApiUrl = getApiURL("cityCenterApiUrl");
  const workflowApiUrl = getApiURL("workflowApiUrl");
  api = axios.create({
    baseURL: cityCenterApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    timeout: Number(axiosTimeout)
  });

  wfApi = axios.create({
    baseURL: workflowApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*"
    },
    timeout: Number(axiosTimeout)
  });

  forLogin = axios.create({
    baseURL: cityCenterApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    timeout: Number(axiosTimeout)
  });

  api.interceptors.request.use(config => config);
  api.interceptors.response.use(
    response => response
    // error => {
    //   console.log("error");
    //   // if (error.response.status === 401) {
    //   setLocalStorageItem("cityCenterLoggedIn", JSON.stringify(false));
    //   window.dispatchEvent(
    //     new CustomEvent("cc-loggedIn-localstorage-changed", {
    //       detail: {
    //         storage: localStorage.getItem("cityCenterLoggedIn")
    //       }
    //     })
    //   );
    //   // }
    //   // if (error.response && error.response.data) {
    //   //   //add your code
    //   //   console.log(error.response.data);
    //   //   return Promise.reject(error.response.data);
    //   // }
    //   return Promise.reject(error.message);
    // }
  );

  forLogin.interceptors.response.use(response => response);

  wfApi.interceptors.request.use(config => config);
}

const updateAuthorization = keycloak => {
  // console.log(keycloak);
  const authHeaderValue = `Bearer ${keycloak.token}`;
  api.defaults.headers.common["Authorization"] = authHeaderValue;
  wfApi.defaults.headers.common["Authorization"] = authHeaderValue;
  forLogin.defaults.headers.common["Authorization"] = authHeaderValue;
};

export default {
  getPersonnelActions: () => api.get(`/PersonnelAction`),
  getPersonnelChanges: () => api.get(`/PersonnelChange`),
  getTimeEntries: () => api.get(`/TimeEntry`),
  getLeaveRequests: (url = "", c) => api.get(url + "/" + c),
  getLeaveBalance: (url = "", c) => api.get(url + "/" + c),
  getTimeSheets: () => api.get(`/TimeSheet`),
  getUserDetail: (url = "", c) => api.get(url + "/" + c),
  get: (url = "", item) => api.get(url + "/" + item),
  post: (url = "", item) => api.post(url, JSON.stringify(item)),
  patch: (url = "", item) => api.patch(url, item),
  put: (url = "", c) => api.put(url, c),
  deleteWithPayload: (url = "", c) => api.delete(url, { data: c }),
  loginPost: (url = "", c) => forLogin.post(url, JSON.stringify(c)),
  postProfileImage: (url = "", c) => api.post(url, c),
  getWithoutPayload: (url = "") => api.get(url),
  delete: (url = "", item) => api.delete(url + item),
  wfApiDelete: (url = "", item) => wfApi.delete(url + item),
  wfApiPost: (url = "", c) => wfApi.post(url, c),
  wfApiPut: (url = "", c) => wfApi.put(url, c),
  wfApiGet: (url = "", item) => wfApi.get(url + "/" + item),
  wfApiGetWithoutPayload: (url = "") => wfApi.get(url),
  wfApiPatch: (url = "", c) => wfApi.patch(url, c),
  updateAuthorization: keycloak => updateAuthorization(keycloak)
};
export { buildApi };
